import axios from 'axios'
import { Toast } from 'vant'
import { getToken } from '@/utils/auth'
import store from '@/store'

let service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 5000000 // request timeout
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Token'] = getToken()
    }
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => response,
  // response => {},
  error => {
    console.log('err' + error) // for debug

    if (error.response.status === 401) {
      store.dispatch('Logout')
      window.location.reload()
    } else {
      if (error.response) {}
      let msg = error.response.data.message || '网络错误'
      Toast(msg)
    }
    return Promise.reject(error)
  }
)

export default service
